module.exports = __webpack_public_path__ + "img/fig_rosalee_en.1f663e33.png";